import * as React from "react";

import { Button } from "semantic-ui-react";

import { TaskActionProps } from "../model";

import { ActiveTaskAction } from "./ActiveTaskAction";

import { Link } from "redux-little-router";

export const BookAppointmentButton: React.FunctionComponent<TaskActionProps> = (props) => {
    return (
        <ActiveTaskAction task={props.task}>
            <Link
                href={{
                    pathname: "/book-appointments",
                    query: {
                        bookTaskId: props.task.id
                    }
                }}
            >
                <Button content="Book appointment" floated="right" />
            </Link>
        </ActiveTaskAction>
    );
};
